import { ErrorHandler, Injectable } from '@angular/core';
import { TrackJS } from 'trackjs';

type WrappedError = Error & {
  cause?: unknown;
  ngOriginalError?: unknown;
};

export function unwrapTrackjsError(error: unknown): Error | object | string {
  let current: unknown = error;

  while (current instanceof Error) {
    const wrapped = current as WrappedError;
    const next = wrapped.cause ?? wrapped.ngOriginalError;

    if (next === undefined || next === current) {
      return current;
    }

    current = next;
  }

  if (typeof current === 'string') {
    return current;
  }

  if (typeof current === 'object' && current !== null) {
    return current;
  }

  return new Error(String(current));
}

@Injectable()
export class TrackjsErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    const cause = unwrapTrackjsError(error);

    if (TrackJS.isInstalled()) {
      TrackJS.track(cause);
    }

    // console.warn, not console.error — the error channel auto-reports at default settings.
    console.warn(error);
  }
}
